export const mediaQueryInSP = (styles: string) => `@media (max-width: 540px) {
${styles}
}`;
export const mediaQueryInTablet = (
  styles: string
) => `@media (max-width: 768px) {
${styles}
}`;
